import { Eye, Code, Columns, Download, Loader2 } from 'lucide-react';

const EditorToolbar = ({ viewMode, setViewMode, onExport, isAnalyzing }) => {
  const ViewButton = ({ mode, icon: Icon, label }) => (
    <button
      onClick={() => setViewMode(mode)}
      className={`px-3 py-2 rounded-md text-sm font-medium transition-all flex items-center ${
        viewMode === mode
          ? 'bg-rose-500 text-white shadow-sm'
          : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
      }`}
    >
      <Icon size={16} className="mr-2" />
      {label}
    </button>
  );

  return (
    <div className="bg-slate-50 border-b border-slate-200 p-3 flex items-center justify-between">
      <div className="flex space-x-2">
        <ViewButton mode="editor" icon={Code} label="Editor" />
        <ViewButton mode="split" icon={Columns} label="Split View" />
        <ViewButton mode="preview" icon={Eye} label="Preview" />
      </div>

      <div className="flex items-center space-x-3">
        {isAnalyzing && (
          <span className="text-xs text-slate-500 flex items-center">
            <Loader2 size={14} className="mr-1 animate-spin" />
            Analyzing changes...
          </span>
        )}
        <button
          onClick={onExport}
          className="bg-slate-700 hover:bg-slate-800 text-white px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center"
        >
          <Download size={16} className="mr-2" />
          Export .fountain
        </button>
      </div>
    </div>
  );
};

export default EditorToolbar;
